var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":"200px","aspect-ratio":_vm.aspectRatio,"src":_vm.url ? _vm.url : 'img/icon.png'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }